import Tab from '@mui/material/Tab';
import { StyledTabs } from '@openx/components-core/lib/Tabs/Tabs.tsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UnforecastedTargetingSectionTab } from '../../../types.ts';

import { UnforecastedTargetingTable } from './UnforecastedTargetingTable.tsx';

export const UnforecastedTargetingSection = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<UnforecastedTargetingSectionTab>(UnforecastedTargetingSectionTab.AdSize);

  return (
    <>
      <StyledTabs
        onChange={(_, value) => setActiveTab(value)}
        value={activeTab}
        sx={{ backgroundColor: 'transparent' }}
      >
        <Tab data-test="ad-sizes-tab" label={t('Ad Size')} value={UnforecastedTargetingSectionTab.AdSize} />
        <Tab
          data-test="video-duration-tab"
          label={t('Video Duration')}
          value={UnforecastedTargetingSectionTab.VideoDuration}
        />
        <Tab data-test="cities-tab" label={t('US City')} value={UnforecastedTargetingSectionTab.USCity} />
      </StyledTabs>

      <UnforecastedTargetingTable key={activeTab} type={activeTab} />
    </>
  );
};
